export const AUTH_TYPE_SELECTION = 'AUTH_TYPE_SELECTION';
export const EMAIL_VERIFICATION_INFO = 'EMAIL_VERIFICATION_INFO';
export const PHONE_VERIFICATION_INPUT = 'PHONE_VERIFICATION_INPUT';
export const VERIFICATION_SUCCEEDED = 'VERIFICATION_SUCCEEDED';



// WEBPACK FOOTER //
// ./app/constants/studentSignupStages.js